/* ---------------------------------------------------------------------------------------------------------------------
PRIORITY NAV JS
--------------------------------------------------------------------------------------------------------------------- */
jQuery(document).ready(function ($) {
    const nav = priorityNav.init({
        mainNavWrapper: ".priority-nav", // mainnav wrapper selector (must be direct parent from mainNav)
        mainNav: ".sub-nav-links", // mainnav selector. (must be inline-block)
        navDropdownLabel: 'More',
        navDropdownBreakpointLabel: "View Menu", //button label for navDropdownToggle when the breakPoint is reached.
        navDropdownClassName: "nav__dropdown", // class used for the dropdown.
        navDropdownToggleClassName: "nav__dropdown-toggle", // class used for the dropdown toggle.
        breakPoint: 946, //amount of pixels when all menu items should be moved to dropdown to simulate a mobile menu
        throttleDelay: 0, // this will throttle the calculating logic on resize because i'm a responsible dev.
        offsetPixels: 0, // increase to decrease the time it takes to move an item.
        count: true, // prints the amount of items are moved to the attribute data-count to style with css counter.
    });
});
